import React from 'react';

const FormStep = ({ children, islastStep, active, loading, onSubmit }) => {
  const className = `form__button ${loading ? 'loading' : ''}`;
  return (
    active && (
      <div className="form__step">
        {children}
        <button type="submit" className={className} onClick={onSubmit}>
          {islastStep ? 'Enviar Participação' : 'Seguinte'}
        </button>
      </div>
    )
  );
};

export default FormStep;
